/** The browsers whose stores list the extension, in their own colours. */

/** Chrome: three sectors round the blue centre, beside "Add to Chrome". */
export function ChromeIcon({ className = "size-4" }: { className?: string }) {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className={className}>
            <path
                d="M12 7h9.798A11 11 0 0 0 2.772 6.013L7.670 14.500A5 5 0 0 1 12 7z"
                fill="#EA4335"
            />
            <path
                d="M7.670 14.500 2.772 6.013A11 11 0 0 0 11.432 22.985L16.330 14.500A5 5 0 0 1 7.670 14.500z"
                fill="#34A853"
            />
            <path
                d="M16.330 14.500 11.432 22.985A11 11 0 0 0 21.798 7H12a5 5 0 0 1 4.330 7.500z"
                fill="#FBBC04"
            />
            <circle cx="12" cy="12" r="5" fill="#fff" />
            <circle cx="12" cy="12" r="4" fill="#1A73E8" />
        </svg>
    );
}
